export const defaultState = {
  advertisements: [],
  requisitionQualifications: [],
  requisitionCertificates: [],
  requisitionCompetencies: [],
  applications: [],
  internshipApplications: [],
  internshipApplication: null,
  placementRejectionReasons: [],
  placementRejectionLogs: [],
  applicationPlacements: {},
  waitingList: [],
  waitingListDetails: [],
  selectedAdvertisement: null,
  appeal: {},
  announcements: [],
  advertisementPsychometricLanguages: [],
  advertisementKnowledgeSubDomains: [],
};
